export function Card({
  children,
  hoverable = true,
  padded = true,
  as = "div",
  className = "",
  ...rest
}) {
  const Tag = as;
  const cls = [
    "card",
    hoverable ? "card-hoverable" : "",
    padded ? "card-padded" : "",
    className,
  ].filter(Boolean).join(" ");
  return (
    <Tag className={cls} {...rest}>
      {children}
    </Tag>
  );
}
